// Magento rejects a match filter shorter than this ("Invalid match filter.
// Minimum length is 3.") — shared by the desktop search bar and the mobile
// search trigger/panel, all three of which debounce against it.
export const MIN_QUERY_LENGTH = 3;
